import { render, staticRenderFns } from "./RatingUserTable.vue?vue&type=template&id=cc079c7c&scoped=true&lang=html"
import script from "./RatingUserTable.vue?vue&type=script&lang=js"
export * from "./RatingUserTable.vue?vue&type=script&lang=js"
import style0 from "./RatingUserTable.vue?vue&type=style&index=0&id=cc079c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc079c7c",
  null
  
)

export default component.exports